import { EBrowserStorageType } from '@/core/apis/browser_storage_api/browser_storage_api_types';
import { StorageHandler } from '@/core/data_handlers/storage_handler';
import { Logger } from '@/shared/logger/logger';

import { SESSION_ID_KEY } from '../constants';
import { ShopifyCartApi } from '../shpfy_api/shpfy_cart_api';

// eslint-disable-next-line unicorn/no-static-only-class
export class ShopifyCartAttributeSync {
  static cartAttributeStorage: StorageHandler<string> =
    new StorageHandler<string>(
      'cartAttributes',
      '',
      EBrowserStorageType.LOCALSTORAGE,
    );

  static injectNoteAttributes = async (sessionId: string) => {
    const cartAttributes = {
      [SESSION_ID_KEY]: sessionId,
    };

    const cachedCartAttributes =
      ShopifyCartAttributeSync.cartAttributeStorage.get();

    // Convert cartAttributes object to JSON string for comparison
    const cartAttributesJson = JSON.stringify(cartAttributes);

    // Check if the cart attributes have changed
    if (cachedCartAttributes === cartAttributesJson) {
      return;
    }

    try {
      await ShopifyCartApi.updateCart(cartAttributes);
      // Update local storage with the new cart attributes
      ShopifyCartAttributeSync.cartAttributeStorage.set(cartAttributesJson);
    } catch (error) {
      Logger.error('Error in Injecting Note Attributes', error);
    }
  };
}
